import React from 'react';
import PropTypes from 'prop-types';

import { ModalWindow, FormsCollection } from '../../../../components';
import { FilesField, FilesItem } from './components/index';
import './style.sass';

const ImportCustomers = ({
  isOpen, onImportCustomers, isPending, onCloseModal, onChange, loadingFiles, onDeleteFile,
}) => (
  <ModalWindow
    isOpen={isOpen}
    onClose={onCloseModal}
    modalName="attachFiles"
    title="Import customers"
    className="modal-window__attach-files"
  >
    <FormsCollection.FormWrapper
      onSubmit={onImportCustomers}
      className="attach-files"
    >
      <FilesField pending={isPending} onlyOne onChange={onChange} />
      <div className="attach-files__uploaded-files">
        {
          loadingFiles.map(item => (
            <FilesItem item={item} key={`item-file${item.filename}`} onDelete={onDeleteFile} />
          ))
        }
      </div>
      <div className="button-group">
        <button
          type="submit"
          className="btn-primary btn w-100px"
        >
          UPLOAD
        </button>
      </div>
    </FormsCollection.FormWrapper>
  </ModalWindow>
);
ImportCustomers.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onImportCustomers: PropTypes.func.isRequired,
  isPending: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  loadingFiles: PropTypes.instanceOf(Array).isRequired,
  onDeleteFile: PropTypes.func.isRequired,
};

export default ImportCustomers;
